export default {
  BAD_INPUT_ERROR: '入力内容に誤りがあります。',
  ACCESS_DENIED_ERROR: '指定の処理を行う権限がありません。',
}
